/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {skipBlocker} from '../api'

export const useMutationSkipBlocker = createReactQueryMutationHook('skipBlocker', skipBlocker)
